/* Montcliffe custom JS (Horizon || OPT Backup)
   - Detects every "Icons with text" section (icon + title + subtitle
     rows) on ANY page and turns it into an auto-playing mobile slider
     with dot navigation. Adds the class `mont-iconrow` so the CSS can
     style them. No template JSON is touched. */
(function () {
  'use strict';

  var MOBILE = '(max-width: 749px)';

  function isMobile() {
    return window.matchMedia(MOBILE).matches;
  }

  /* An "Icons with text" section = a section whose content wrapper holds
     2+ group-block columns, each containing an icon block. This matches
     the guarantee/USP rows and nothing else (plain text sections have no
     icon blocks). */
  function findIconRows() {
    var out = [];
    var secs = document.querySelectorAll('.shopify-section');
    Array.prototype.forEach.call(secs, function (s) {
      var wrap = s.querySelector('.section-content-wrapper');
      if (!wrap) return;
      var cols = Array.prototype.filter.call(wrap.children, function (c) {
        return c.classList && c.classList.contains('group-block');
      });
      var iconCols = cols.filter(function (c) {
        return c.querySelector('.icon-block, [class*="icon-block"]');
      });
      if (cols.length >= 2 && iconCols.length >= 2) out.push(s);
    });
    return out;
  }

  function initIconRow(section) {
    section.classList.add('mont-iconrow');

    var track = section.querySelector('.section-content-wrapper');
    if (!track || track.dataset.montSlider) return;

    var slides = Array.prototype.filter.call(track.children, function (c) {
      return c.classList && c.classList.contains('group-block');
    });
    if (slides.length < 2) return;

    track.dataset.montSlider = '1';

    // build dots
    var dots = document.createElement('div');
    dots.className = 'mont-refund-dots';
    slides.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mont-dot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      b.addEventListener('click', function () {
        goTo(i, true);
      });
      dots.appendChild(b);
    });
    track.insertAdjacentElement('afterend', dots);

    var current = 0;
    var userInteracted = false;

    function setActive(i) {
      current = i;
      var kids = dots.children;
      for (var j = 0; j < kids.length; j++) {
        kids[j].classList.toggle('is-active', j === i);
      }
    }

    function goTo(i, fromClick) {
      if (fromClick) userInteracted = true;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      setActive(i);
    }

    // keep dots in sync while scrolling / swiping
    var scrollTimer;
    track.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) setActive(i);
      }, 60);
    });

    track.addEventListener('touchstart', function () {
      userInteracted = true;
    }, { passive: true });

    // autoplay (mobile only, pauses once the user takes over)
    window.setInterval(function () {
      if (!isMobile() || userInteracted) return;
      var next = (current + 1) % slides.length;
      goTo(next, false);
    }, 3500);
  }

  function boot() {
    findIconRows().forEach(initIconRow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);
})();
